import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { API_ROUTES } from '../config/api';
import { PaginatedResponse, SalesRecord } from '../types/api.types';

export interface UseSalesListOptions {
  page?: number;
  pageSize?: number;
  articleIds?: string[];
  enabled?: boolean;
}

/**
 * Hook to fetch paginated list of sales records for a database
 */
export function useSalesList(
  databaseId: number | string | null,
  options?: UseSalesListOptions
) {
  const { page = 1, pageSize = 50, articleIds, enabled = true } = options || {};

  return useQuery<PaginatedResponse<SalesRecord>>({
    queryKey: ['salesList', databaseId, page, pageSize, articleIds],
    queryFn: async () => {
      if (!databaseId) {
        throw new Error('Database ID is required');
      }

      const params: any = {
        page,
        page_size: pageSize,
      };

      // Add article_ids filter if provided
      if (articleIds && articleIds.length > 0) {
        params.article_ids = articleIds.join(',');
      }

      const response = await api.get(
        `${API_ROUTES.DB_MANAGER.BASE}${API_ROUTES.DB_MANAGER.SALES_LIST(databaseId)}`,
        { params }
      );

      return response.data;
    },
    enabled: !!databaseId && enabled,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
  });
}

